import { FOOTER_LINKS } from '../data/content';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <div className="footer__logo">
            <div className="footer__icon">
              <svg width="18" height="18" viewBox="0 0 32 32" fill="none">
                <circle cx="16" cy="16" r="14" stroke="#1DD9C5" strokeWidth="2"/>
                <path d="M10 22 L16 10 L22 22" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 18h8" stroke="#1DD9C5" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <div>
              <div className="footer__name">Ai<span>va</span></div>
              <div className="footer__tagline">Domain-Specific AI Agents</div>
            </div>
          </div>
          <p className="footer__desc">
            Aiprus Software builds intelligent, domain-specific AI agents that answer,
            guide, escalate, and act across HR, sales, IT, finance, and custom workflows.
          </p>
          <div className="footer__contact-chips">
            <a href="mailto:info@aiprus.com" className="footer__chip">📧 info@aiprus.com</a>
            <a href="tel:+918420006452"           className="footer__chip">📞 +91-842-000-6452</a>
            <a href="https://www.aiprus.com" target="_blank" rel="noreferrer" className="footer__chip">🌐 aiprus.com</a>
          </div>
        </div>

        <div className="footer__links-col">
          <p className="footer__col-title">Our Bots</p>
          {['HR Assistant','Sales & Marketing','IT Helpdesk','Finance & Expense',
            'Employee Onboarding','Vendor & Procurement','Customer Support','Custom Domain'].map(b => (
            <a key={b} href="#bots" className="footer__link">{b} Bot</a>
          ))}
        </div>

        <div className="footer__links-col">
          <p className="footer__col-title">Platform</p>
          {['How It Works','Dynamic Reports','Integrations','Channels','Security & Privacy'].map(l => (
            <a key={l} href="#" className="footer__link">{l}</a>
          ))}
          <a href="#pricing" className="footer__link">Pricing</a>
        </div>

        <div className="footer__links-col">
          <p className="footer__col-title">Company</p>
          {['About Aiprus','Blog','Case Studies','Documentation','Support','Contact'].map(l => (
            <a key={l} href="#" className="footer__link">{l}</a>
          ))}
        </div>
      </div>

      <div className="footer__bottom">
        <span>© 2025 Aiprus Software. All rights reserved.</span>
        <div className="footer__legal">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
          <a href="#">Cookie Policy</a>
        </div>
      </div>
    </footer>
  );
}
